import React from 'react';
import clsx from 'clsx';

const tones = {
  cyan: {
    border: 'border-[var(--neon-cyan)]/20',
    hover: 'hover:border-[var(--neon-cyan)]/50 hover:shadow-[0_0_30px_rgba(0,240,255,0.15)]',
    glow: 'before:bg-gradient-to-r before:from-[var(--neon-cyan)] before:to-[var(--neon-violet)]',
    accent: 'text-[var(--neon-cyan)]',
  },
  pink: {
    border: 'border-[var(--neon-pink)]/20',
    hover: 'hover:border-[var(--neon-pink)]/50 hover:shadow-[0_0_30px_rgba(255,42,109,0.15)]',
    glow: 'before:bg-gradient-to-r before:from-[var(--neon-pink)] before:to-[var(--neon-violet)]',
    accent: 'text-[var(--neon-pink)]',
  },
  violet: {
    border: 'border-[var(--neon-violet)]/20',
    hover: 'hover:border-[var(--neon-violet)]/50 hover:shadow-[0_0_30px_rgba(168,85,247,0.15)]',
    glow: 'before:bg-gradient-to-r before:from-[var(--neon-violet)] before:to-[var(--neon-cyan)]',
    accent: 'text-[var(--neon-violet)]',
  },
};

export default function Panel({
  children,
  tone = 'cyan',
  glow = true,
  padding = 'md',
  className = '',
  ...rest
}) {
  const t = tones[tone] || tones.cyan;
  const padCls = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-7',
  }[padding];

  return (
    <div
      className={clsx(
        'relative bg-[var(--bg-glass)] border backdrop-blur-md rounded-2xl overflow-hidden transition-all duration-300',
        t.border,
        t.hover,
        padCls,
        className
      )}
      {...rest}
    >
      {glow && (
        <span
          className={clsx(
            'absolute top-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity',
            t.glow,
            'before:block before:w-full before:h-full'
          )}
        />
      )}
      {children}
    </div>
  );
}